import { styled } from 'next-yak';

import {
  background_01_1x1_a,
  background_01_7x2_a,
  background_04_1x1_a,
  background_04_7x2_a,
} from '@xing-com/background-images';
import {
  mediaSmallOrTiny,
  zIndexBackgroundLayer1,
} from '@xing-com/layout-tokens';
import { xdlPaletteGrayCool11, xdlPaletteWhite } from '@xing-com/tokens';

export const Background = styled.div`
  display: block;
  position: absolute;
  width: 100%;
  height: 480px;
  top: 0;
  left: 0;
  z-index: ${zIndexBackgroundLayer1};
  background-image: ${() => `url('${background_01_7x2_a}')`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media ${mediaSmallOrTiny} {
    background-image: ${() => `url('${background_01_1x1_a}')`};
  }

  &::after {
    position: absolute;
    inset: 0;
    content: '';
    background: linear-gradient(to top, ${xdlPaletteWhite} 0%, transparent 60%);
  }

  @media (prefers-color-scheme: dark) {
    background-image: ${() => `url('${background_04_7x2_a}')`};

    &::after {
      background: linear-gradient(
        to top,
        ${xdlPaletteGrayCool11} 0%,
        transparent 60%
      );
    }
  }

  @media (prefers-color-scheme: dark) and ${mediaSmallOrTiny} {
    background-image: ${() => `url('${background_04_1x1_a}')`};
  }
`;
